module.exports = __webpack_public_path__ + "static/media/logo_vietbank.12f25fc4.svg";